
export { SectionTitleSmall } from "./SectionTitle"